// src/data/offers.js

export const categories = [
  { id: "content1", label: "Advertising & PR",       subtitle: "Inspire to action" },
  { id: "content2", label: "Marketing Packages",      subtitle: "Choose your coverage" },
  { id: "content3", label: "Digital Marketing",       subtitle: "Step into unlimited potential" },
  { id: "content4", label: "Content Production",      subtitle: "From script to screen" },
  { id: "content5", label: "Promotional Events",      subtitle: "Convert fanbase to clientbase" },
];

export const slides = [
  {
    id: 1,
    link: "/",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c",
    titleClass:    "item-titleone",
    subtitleClass: "item-subtitleone",
    label:         categories[0].label,
    subtitle:      categories[0].subtitle,
  },
  {
    id: 2,
    link: "https://flourishtalents.com/",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3",
    titleClass:    "item-titletwo",
    subtitleClass: "item-subtitletwo",
    label:         categories[1].label,
    subtitle:      categories[1].subtitle,
  },
  {
    id: 3,
    link: "https://flourishtalents.com/",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c",
    titleClass:    "item-titlethree",
    subtitleClass: "item-subtitlethree",
    label:         categories[2].label,
    subtitle:      categories[2].subtitle,
  },
  {
    id: 4,
    link: "https://flourishtalents.com/",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fnile%20bridge%20new%20yr%20lights.jpg?alt=media&token=a7933475-3b89-40c3-8534-c3ec11db97a3",
    titleClass:    "item-titlefour",
    subtitleClass: "item-subtitlefour",
    label:         categories[3].label,
    subtitle:      categories[3].subtitle,
  },
  {
    id: 5,
    link: "https://flourishtalents.com/",
    bgImage:
      "https://firebasestorage.googleapis.com/v0/b/flourishtalents1.appspot.com/o/public%2Fimages%2Fweblogo.png?alt=media&token=a6fe6e55-0807-4294-969b-e064bdee026c",
    titleClass:    "item-titlefive",
    subtitleClass: "item-subtitlefive",
    label:         categories[4].label,
    subtitle:      categories[4].subtitle,
  },
];
